export enum Type {
  MODAL_PUSH = 'app/modal/MODAL_PUSH',
  MODAL_HIDE = 'app/modal/MODAL_HIDE',
  MODAL_POP = 'app/modal/MODAL_POP',
  MODAL_REPLACE = 'app/modal/MODAL_REPLACE',
  MODAL_UPDATE = 'app/modal/MODAL_UPDATE',
}
